module.exports = __webpack_public_path__ + "img/04.4c871eb4.jpg";